/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import FilterDateClause from 'bundles/enterprise-admin-user-filters/components/FilterDateClause';
import type { ActivityFilter, DateClause } from 'bundles/enterprise-admin-user-filters/types';
import { formatDate } from 'bundles/enterprise-admin-user-filters/utils';

import _t from 'i18n!nls/enterprise-admin-user-filters';

type Props = {
  activityFilter: ActivityFilter;
  onActivityFilterChange: (activityFilter: ActivityFilter) => void;
};
const ActivityFilterDateClause: React.VFC<Props> = ({ activityFilter, onActivityFilterChange }) => {
  const dateClause = activityFilter?.enrollmentDate;

  const defaultHeading = _t('Enrolled');
  const options = [
    {
      value: 'ANYTIME',
      label: _t('Enrolled at any time'),
      heading: _t('Enrolled at any time'),
    },
    {
      value: 'AFTER',
      label: _t('Enrolled after date'),
      heading:
        dateClause && dateClause.type === 'ABSOLUTE' && dateClause.after ? (
          <FormattedMessage message={_t('Enrolled after {after}')} after={formatDate(dateClause.after)} />
        ) : (
          defaultHeading
        ),
    },
    {
      value: 'BETWEEN',
      label: _t('Enrolled between'),
      heading:
        dateClause && dateClause.type === 'ABSOLUTE' && dateClause.after && dateClause.before ? (
          <FormattedMessage
            message={_t('Enrolled between {after} and {before}')}
            after={formatDate(dateClause.after)}
            before={formatDate(dateClause.before)}
          />
        ) : (
          defaultHeading
        ),
    },
    {
      value: 'LAST_N_DAYS',
      label: _t('Enrolled in the last'),
      heading:
        dateClause && dateClause.type === 'RELATIVE'
          ? _t('Enrolled in the last #{count} days', { count: dateClause.nDaysAgoAfter })
          : defaultHeading,
    },
  ];

  const handleDateClauseChange = (newDateClause: DateClause) => {
    onActivityFilterChange({ ...activityFilter, enrollmentDate: newDateClause });
  };

  return (
    <FilterDateClause
      label={_t('Enroll date filter clause')}
      options={options}
      dateClause={dateClause}
      onChange={handleDateClauseChange}
      nDaysAgoField="nDaysAgoAfter"
    />
  );
};
export default ActivityFilterDateClause;
